import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const PlanetGlyph = /*#__PURE__*/createElement("g", {
  id: "planet",
  transform: "scale(3.2)",
  fill: "none"
}, /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z"
}), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.6476 24.995C6.1832 24.8086 1 19.5096 1 13C1 12.8892 1.0015 12.7786 1.00449 12.6685C1.88311 12.7525 3.47516 12.9432 3.55017 13.5606C3.65399 14.4146 3.55017 15.4822 4.27739 15.8024C5.00462 16.1226 5.21242 14.5213 5.83566 14.9484C6.45891 15.3755 8.12116 15.7866 8.12116 16.5417C8.12116 17.2966 7.80953 18.4713 8.12116 18.6849C8.43278 18.8984 9.67862 20.3929 9.67894 20.6064C9.67942 20.82 10.1181 21.9058 9.9872 22.3209C9.87873 22.665 9.33143 23.7336 8.8008 24.2194C10.0042 24.6828 11.2981 24.9546 12.6476 24.995Z"
}), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.04227 2.06816C9.55309 1.38209 11.2312 1 12.9986 1C17.6806 1 21.7363 3.6813 23.7139 7.59211C23.7582 8.63217 23.7504 9.52181 23.9801 9.84365C25.1496 11.4801 21.1313 12.6058 21.7417 15.0807C22.0106 16.1727 19.069 15.8262 18.3506 16.8485C17.6317 17.8703 15.8752 17.1838 15.468 16.9873C15.0607 16.7909 13.5008 17.4455 13.6372 16.3327C13.7727 15.2195 14.7217 15.1542 15.7394 14.6959C16.7566 14.2382 18.2239 12.7162 17.5029 12.5173C14.1084 11.5817 12.9503 8.3047 12.9503 8.3047C12.7467 8.26535 12.7978 5.98813 11.9165 5.92276C11.0343 5.85707 10.5593 6.18455 9.27111 5.92276C7.98217 5.66098 8.25389 4.80992 8.05026 2.97674C8.00469 2.56554 8.00689 2.27623 8.04227 2.06816Z"
}));
const Planet = createSvg({
  name: 'planet',
  path: PlanetGlyph
});

export default Planet;
export { PlanetGlyph };
